"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  youHaveUnsavedChangesBeforeLeave: 'Имеются несохраненные данные. Вы уверены, что хотите уйти со страницы?',
  stringHasErrors: 'Строка содержит ошибку, данные не сохранены',
  numberCantBeMore: 'Число должно быть не более 10000'
};